import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import AboutUs from "./Pages/About_Us";
import Contact from "./Pages/Contact"; // Create this file if it doesn't exist
import "./index.css";
import Footer from "./Components/Footer";
import OurServices from "./Pages/Our_Services";
import OurProjects from "./Pages/Our_Projects"; // Import the ProjectsTable component

const App = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <div className="app-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/our-services" element={<OurServices />} />
          <Route path="/our-projects" element={<OurProjects />} />
        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
